import React from "react";
import * as styles from "./BVRatingButton.css";
import { locale } from "../config";
import { cx } from "emotion";

export class BVRatingButton extends React.Component {
    render() {
        const pathNameArray = window.location.pathname.split("/");
        const linkClass = this.props.link ? "link" : "";

        return locale.indexOf(pathNameArray[1]) > -1 ? (
            <button
                className={cx(styles.submitButton, linkClass, "bv-show-rating-button")}
            >
                Написать отзыв
            </button>
        ) : null;
    }
}